/**
 * @file reducer for analytics
 * @author Julius Diaz Panoriñgan
 */

import createAction from '@f/create-action'

export const setAnalyticsConfig = createAction('SET_ANALYTICS_CONFIG')
export const setAnalyticsId = createAction('SET_ANALYTICS_ID')
export const unsetAnalyticsId = createAction('UNSET_ANALYTICS_ID')

export default function(state = {}, action) {
  const { type, payload } = action
  switch (type) {
    case setAnalyticsConfig.type:
      return {
        ...state,
        config: payload !== undefined ? payload : null
      }
    case setAnalyticsId.type:
      return {
        ...state,
        id: payload || null
      }
    case unsetAnalyticsId.type:
      return {
        ...state,
        id: null
      }
    default:
      return state
  }
}
